export const COOLANTS = [
  { displayName: 'bioethanol', code: 'cl_bio' },
  { displayName: 'ethanol', code: 'cl_eth' },
  { displayName: 'ethanolGlycol', code: 'cl_eth_gly' },
  { displayName: 'salineSolution', code: 'cl_salt' },
  { displayName: 'other', code: 'cl_other' }
] as const;

export enum CoolantCode {
  bioethanol = 'cl_bio',
  ethanol = 'cl_eth',
  ethanolGlycol = 'cl_eth_gly',
  salineSolution = 'cl_salt',
  other = 'cl_other'
}

export type Coolant = (typeof COOLANTS)[number];
